<template>
  <section data-aos="fade-right" data-aos-offset="200">
    <div v-bind:class="{ geometry: geometry }"/>
    <div class="section-header">
      <div class="grid-container de-skew">
        <h3 v-text="title"></h3>
        <p v-if="subtext" v-text="subtext"></p>
      </div>
      <!-- shapes inside financial headers -->
        <div class="fin-header-shape-wrap">
          <div class="shape circle circle--fin-header-mid"></div>
          <div class="shape circle circle--fin-header-small"></div>
          <div class="shape triangle triangle--fin-header"></div>
          <div class="shape squares squares--fin-header">
            <div class="square"></div>
          </div>
        </div>
        <!-- end shapes -->
    </div>
    <div class="section-content" data-aos="fade-left" data-aos-offset="200">
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  name: 'VisualDataSection',
  props: {
    title: String,
    subtext: String,
    geometry: Boolean
  },
  mounted () {
    $('.fin-header-shape-wrap').filter(':even').each(function () {
      $(this).addClass('odd');
    });
  }
};
</script>
